// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SignatureV1RecipientViewRequestUrlRequestUrlResponse {
    static getAttributeTypeMap() {
        return SignatureV1RecipientViewRequestUrlRequestUrlResponse.attributeTypeMap;
    }
}
SignatureV1RecipientViewRequestUrlRequestUrlResponse.discriminator = undefined;
SignatureV1RecipientViewRequestUrlRequestUrlResponse.additionalProperties = false;
SignatureV1RecipientViewRequestUrlRequestUrlResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetRecipientViewResponse"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=signatureV1RecipientViewRequestUrlRequestUrlResponse.js.map